import clsx from 'clsx';
import { IconProps } from '../IconProps';

function FirmableShort({ width = 51, height = 64, size = 20, className }: IconProps) {
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className)}>
      <g clipPath="url(#clip0_8286_6182)">
        <path
          d="M115.089 53.7944C117.432 56.1376 117.432 59.9366 115.089 62.2798L98.1536 79.2152C95.8104 81.5584 92.0114 81.5584 89.6683 79.2152L60.0083 49.5552L74.1149 35.4486C80.3632 29.2002 90.4937 29.2001 96.7421 35.4483L115.089 53.7944Z"
          fill="#A94004"
        />
        <path
          d="M71.3177 10.025C65.0693 3.77685 54.9388 3.77681 48.6905 10.025L4.91946 53.7952C2.57633 56.1384 2.57632 59.9374 4.91946 62.2806L21.8548 79.2159C24.1979 81.559 27.997 81.559 30.3401 79.2159L60.0042 49.5518L60.0083 49.556L74.1148 35.4498C80.3631 29.2014 90.4938 29.2013 96.7422 35.4495L71.3177 10.025Z"
          fill="#F15B06"
        />
        <path
          d="M55.7623 70.7438C58.1055 68.4007 61.9045 68.4007 64.2476 70.7438L81.1948 87.691C83.5379 90.0341 83.5379 93.8331 81.1948 96.1763L64.2477 113.123C61.9045 115.467 58.1055 115.467 55.7624 113.123L38.8152 96.1762C36.4721 93.833 36.4721 90.0341 38.8152 87.6909L55.7623 70.7438Z"
          fill="#F15B06"
        />
      </g>
      <defs>
        <clipPath id="clip0_8286_6182">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { FirmableShort };
